<a (click)="openDetail()" class="btn">
    <mat-card  style="width: 8rem;" >
        <img src="{{pokemonUrl}}" mat-card-image alt="..." (error)='onImageError($event)'>
        <mat-divider></mat-divider>
        <mat-card-content class="mt-2">
            <p>{{ this.pokemonName }}</p>
        </mat-card-content>
    </mat-card>
</a>